import { BeamIcon } from 'beam'
import { IconButton } from '@mui/material'
import { ReactElement } from 'react'
import { dataTestIdPrefix } from './constants'
export default function EvaluationFormMultiMenu(): ReactElement {
  return (
    <>
      <IconButton
        color="inherit"
        data-testid={`${dataTestIdPrefix}Multi-Menu-Button`}
        aria-haspopup="true"
      >
        <BeamIcon>DotsVertical</BeamIcon>
      </IconButton>
    </>
  )
}
